import React, {useState} from "react"

import {Button} from "../../shadCn/components/ui/button"


import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../shadCn/components/ui/dialog"
import {createEquipment} from "../../api/equipment/equipmentService";
import {validationChecker} from "../commonmethod/CommonMethod";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import InputBasic from "../input/InputBasic";
import Th_title from "../Th_title";
import {useDispatch} from "react-redux";
import {refresh} from "../../redux/slice/apiSlice";


export function ModalEquipmentWrite({Listener}) {
    const dispatch = useDispatch();
    const [tableData, setTableData] = useState([]);
    const [inputValue, setInputValue] = useState({}); // 입력된 값 상태 관리

    const addRow = () => {
        // 이전 상태를 복사하여 새로운 행을 추가
        setTableData([...tableData, { input1: '', input2: '',input3: '',input4: false, input5: false }]);
    };

    const removeRow = (indexToRemove) => {
        // filter 함수를 사용하여 특정 인덱스를 제외한 새로운 배열 생성
        const updatedTableData = tableData.filter((_, index) => index !== indexToRemove);
        // 변경된 배열을 상태로 설정하여 해당 행을 삭제
        setTableData(updatedTableData);
    };


    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;


        setInputValue({
            ...inputValue, // 기존 상태를 복사하여 기존 데이터 유지
            [name]: type === 'checkbox' ? checked : value // 변경된 필드의 값을 업데이트
        });
    };
    const handleSelectChange = (event) => {
        console.log(event);
        setInputValue({
            ...inputValue,
            approver: event // 선택된 값으로 approver 상태를 업데이트
        });
    };
    const ttest=() => {
        console.log(inputValue)
    }
    const create = async()=>{

        if(!validationChecker(inputValue)) {
            // alert("필수값이 누락되었습니다.")
            return;
        }



        const response = await createEquipment(inputValue);

        if(response && response.status===200) {
            // alert('!!')

            handleActiveToast({message: "등록되었습니다.", labelListener:()=>{}});
            // dispatch(refresh(true));
            setInputValue({});
            setInputValue({required_validate: {equipmentName: false, managementNumber: false, name: false, purpose: false}});
            Listener();

            // document.getElementById('my_btn').click()
            // navigate(`/computerroom/create`)
        }else if(response && response.status===400){
            handleActiveError({message: "등록실패", description: response.data.reason});
            return;
        }

    }





    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button variant="destructive" className="w-min bg-[var(--main-bg-color)] hover:bg-[var(--main-label-color)] text-center">전산장비 반출입 작성</Button>
            </DialogTrigger>
            <DialogContent className="h-[28rem] w-[40rem] max-w-[40rem]">
                <DialogHeader>
                    <DialogTitle>전산장비 반출입 작성</DialogTitle>


                </DialogHeader>

                <table className="w-full create-table h-[300px] ">
                    <tbody className="w-full">
                    <tr>
                        <Th_title title={"구분 출/입 (체크시 반입)"} className="fieldset-td" colspan={2} required={true}>

                            <input

                                type="checkbox"
                                name="ioCheck"
                                checked={inputValue.ioCheck}
                                onChange={handleInputChange}
                                value={true}
                                style={{width: '20px', height: '20px'}}
                            />


                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"장비명 (제조사, 제품명)"} className="fieldset-td" colspan={2} required={true}>
                            <InputBasic
                                target={"equipmentName"}
                                data={{data: inputValue, setData: setInputValue}}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"관리번호 (시리얼 번호)"} className="fieldset-td" colspan={2} required={true}>
                            <InputBasic
                                target={"managementNumber"}
                                data={{data: inputValue, setData: setInputValue}}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"사용자"} className="fieldset-td" colspan={2} required={true}>
                            <InputBasic
                                target={"name"}
                                data={{data: inputValue, setData: setInputValue}}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"용도"} className="fieldset-td" colspan={2} required={true}>
                            <InputBasic
                                target={"purpose"}
                                data={{data: inputValue, setData: setInputValue}}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"비공개 중요 자료 삭제확인"} className="fieldset-td" colspan={2} required={true}>

                            <input

                                type="checkbox"
                                name="deleteCheck"
                                checked={inputValue.deleteCheck}
                                onChange={handleInputChange}
                                value={true}
                                style={{width: '20px', height: '20px'}}
                            />


                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"악성코드 감염 여부 확인"} className="fieldset-td" colspan={2} required={true}>

                            <input

                                type="checkbox"
                                name="infectionCheck"
                                checked={inputValue.infectionCheck}
                                onChange={handleInputChange}
                                value={true}
                                style={{width: '20px', height: '20px'}}
                            />


                        </Th_title>
                    </tr>


                    </tbody>
                </table>


                <div className="flex item-center space-x-2 mt-2">

                    <Button type="button" variant="outline" className="border-current" onClick={create}>
                        작성완료
                    </Button>

                </div>
                {/*<DialogFooter className="sm:justify-start">*/}
                {/*    <DialogClose asChild>*/}
                {/*        <Button type="button" variant="outline">*/}
                {/*            닫기*/}
                {/*        </Button>*/}
                {/*    </DialogClose>*/}
                {/*</DialogFooter>*/}
            </DialogContent>
        </Dialog>
    );

}
